import React, { useEffect, useState } from "react";
import ListMatchesGame from "../home/components/matchGames/components/ListMatchesGame";
import axios from "axios";
import TournamentsSelector from "../home/components/matchGames/components/TournamnetsSelector";
import JournalSelector from "../home/components/matchGames/components/JournalSelector";
import { useFetchMatches } from "../home/components/matchGames/hooks/useFetchMatches";
import { useSelector } from "react-redux";

const ListGamesScreen = ()=>{
    const [currentGroup, setCurrentGroup] = useState('')
    const tournamentId = window.location.pathname?.split('/')?.[2]
    const {matches, selectedTournament,tournaments, labelJournals, labelGroups} = useFetchMatches({hasIdFromParams: true, id: tournamentId});
    const selectedJournal = useSelector(state => state?.matches?.selectedJournal)
    const filterMatchesByJournal = selectedJournal === '' || selectedJournal === 'Todas' || !labelJournals[selectedJournal] ? matches : matches?.filter(match => match?.jornada === selectedJournal)
    const filterMatchesByGroup = currentGroup === '' || currentGroup === 'Todos' ? filterMatchesByJournal : filterMatchesByJournal?.filter(match => match?.equipoLocal?.grupo === currentGroup
 )
    console.log('mathces', filterMatchesByGroup)
    return(
        <div>
            <div>
                <JournalSelector labelJournals={labelJournals}  />
                <div>
                    <select onChange={e => setCurrentGroup(e.target.value)}>
                        {
                            Object.keys(labelGroups)?.map(group =>(
                                <option value={group} >{group}</option>
                            ))
                        }

                    </select>
                </div>

            </div>
            <ListMatchesGame group={currentGroup} filterByGroup={currentGroup !== '' && currentGroup !== 'Todos'} matches={filterMatchesByGroup} />

        </div>
    )
}

export default ListGamesScreen